import {useMemo} from 'react';

import {Icon, IconName, IconSize, IconThickness, Tooltip} from 'components';

type Props = {
    browser: string;
    browserVersion?: string;
    iconSize?: IconSize;
    className?: string;
}

export const BrowserIcon: React.FC<Props> = ({browser, browserVersion, className, iconSize = 'sm'}: Props) => {
    const iconOptions = useMemo<{name: IconName, thickness: IconThickness}>(() => {
        const loweredBrowserValue = String(browser).toLowerCase();
        const options = {
            name: 'browser-unsupported' as IconName,
            thickness: 'xs' as IconThickness
        };

        if (loweredBrowserValue.indexOf('edge') !== -1) {
            options.name = 'browser-edge';
            options.thickness = 'none';
        } else if (loweredBrowserValue.indexOf('chrome') !== -1 || loweredBrowserValue.indexOf('android browser') !== -1) {
            options.name = 'browser-chrome';
            options.thickness = 'none';
        } else if (loweredBrowserValue.indexOf('msie') !== -1) {
            options.name = 'browser-ie';
            options.thickness = 'none';
        } else if (loweredBrowserValue.indexOf('mozilla') !== -1 || loweredBrowserValue.indexOf('firefox') !== -1) {
            options.name = 'browser-firefox';
            options.thickness = 'none';
        } else if (loweredBrowserValue.indexOf('safari') !== -1 || loweredBrowserValue.indexOf('sdk') !== -1) {
            options.name = 'browser-safari';
            options.thickness = 'none';
        } else if (loweredBrowserValue.indexOf('opera') !== -1) {
            options.name = 'browser-opera';
            options.thickness = 'none';
        } else if (loweredBrowserValue.indexOf('samsung internet') !== -1) {
            options.name = 'browser-samsung';
            options.thickness = 'none';
        }

        return options;
    }, [browser]);

    const message = useMemo(() => browser + (browserVersion ? ` ${browserVersion}` : ''), [browser, browserVersion]);

    return (
        <Tooltip message={message} disabled={!browser}>
            <Icon className={className} size={iconSize} {...iconOptions} />
        </Tooltip>
    );
};
